module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/qqtWzV/tc-custom/9781455616367.jpg?1704315958229",
      "alt": "This image is the cover for the book Haunting of Mississippi"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Haunting of Mississippi\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“Excellent . . . provides well-researched history as well as reports of recent unusual phenomenon” —from the author of "), _c('i', [_vm._v("Biloxi Memories")]), _vm._v(" ("), _c('i', [_vm._v("Southern Spirit Guide")]), _vm._v(").")]), _c('br'), _c('br'), _vm._v("The Hospitality State plays hosts to dozens of supernatural entities in this creeptastic guide to the other side. Chilling accounts of poltergeist activity include such landmarks as the McRaven House, where spiteful spirits smack guests without warning and an image of a Confederate soldier appears in contemporary photographs. A section on Anchuca in Vicksburg describes the vision of a woman in a fancy dress who floats through bedroom doors and the sound of dripping water without a source. Other establishments include Merrehope, King’s Tavern, and the Williams Gingerbread House."), _c('br'), _c('br'), _c('b', [_vm._v("“Sucked me right in to Mississippi’s rich, haunted history. Sillery eloquently describes the settings of her stories, so I could easily visualize each of the places she writes about . . . At some points, I was scared out of my bones.” —"), _c('i', [_vm._v("Jackson Free Press")])])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Barbara Sillery\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Barbara Sillery is the owner and president of Keepsake Productions, Inc. and Lagniappe Media, a television production company. A producer and writer with a penchant for the paranormal, she earned a bachelor’s degree in theater and speech from Marywood University. She is also the author of Pelican’s The Haunting of Louisiana")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pelican Publishing company\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0